import React from 'react';

function Inquiry() {
  return <div className="p-4 bg-gray-100 rounded-lg">Inquiry content goes here.</div>;
}

export default Inquiry;
